module.exports = __webpack_public_path__ + "ce183b43c39c73538be784cf26e9c977.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/BG.svg
// module id = SqZ8
// module chunks = 0